
export default function Services() {
  const services = [
    {
      icon: 'ri-bug-line',
      title: 'General Pest Control',
      description: 'Comprehensive treatment for ants, roaches, spiders, and other common household pests.',
      features: ['Quarterly Service', 'Interior & Exterior', 'Guaranteed results']
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Mosquito Control',
      description: 'Advanced mosquito treatment and prevention to protect your outdoor spaces.',
      features: ['Monthly Service', 'In2Care System', 'Free Re-service']
    },
    {
      icon: 'ri-mickey-line',
      title: 'Rodent Control',
      description: 'Safe and effective removal of mice, rats, and other rodents from your home.',
      features: ['Exclusion', 'Trapping', 'Carcass Removal']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Pest Control Services
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From common household pests to specialized treatments, we provide comprehensive solutions tailored to your specific needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-700 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-600">
              <div className="w-16 h-16 flex items-center justify-center bg-green-600/20 rounded-2xl mb-6">
                <i className={`${service.icon} text-3xl text-green-400`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-300">
                    <div className="w-5 h-5 flex items-center justify-center mr-3">
                      <i className="ri-check-line text-green-400 text-lg"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="mt-6 w-full bg-green-600 text-white py-3 rounded-full font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                Learn More
              </button>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <button className="bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
            Get Custom Quote
          </button>
        </div>
      </div>
    </section>
  );
}
